var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-timeline" }, [
    _c("div", { staticClass: "order-timeline-heading" }, [
      _vm._v("\n    Return Timeline\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "order-timeline-content" }, [
      _c(
        "div",
        { attrs: { id: "order-timeline-statuses" } },
        _vm._l(_vm.timeline, function (status, idx) {
          return _c(
            "ReturnTimelineStatus",
            _vm._b({ key: idx }, "ReturnTimelineStatus", status, false)
          )
        }),
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }